import apiClient from '../apiClient';
import { UPLOAD_COMMIT_ACCOMODATION_PROFILE_URL } from '../apiUrl';

const uploadMasterAccomodationProfileApi = data => {
  return apiClient.post(UPLOAD_COMMIT_ACCOMODATION_PROFILE_URL, data);
};

export default uploadMasterAccomodationProfileApi;
